// extracted by mini-css-extract-plugin
module.exports = {"row-divider":"FlexibleDepositConfirmation_row-divider_1zL9M"};